import React from 'react';
import { CommonSelect } from '../../CommonComponents';
import CommonDatePicker from '../../CommonComponents/CommonDatePicker';

const frequencies = [{
  text: 'Every 15 Days',
  value: 'Every15Days',
}, {
  text: 'Start & End Date',
  value: 'StartEndDate',
}, {
  text: 'Custom Date',
  value: 'CustomDate',
}]
const AssignFrequency = ({
  selectedFrequency, selectedDates, estimateEndDate, estimateStartDate,
}) => {
  const [frequency, selectFrequency] = React.useState(null);
  const handleChange = (val) => {
    selectFrequency(val)
    selectedFrequency(val);
  }
  return (
    <div>
      <CommonSelect options={frequencies} label="Frequency" handleChange={handleChange} />
      {frequency === 'CustomDate'
        ? (
          <CommonDatePicker
            selectedDates={selectedDates}
            estimateEndDate={estimateEndDate}
            estimateStartDate={estimateStartDate}
          />
        )
        : null}
    </div>
  );
}

export default AssignFrequency;
